// extracted by css-extract-rspack-plugin
export default {"root":"GYsq6abGDmY8F7HW","logo":"_23N2NSnBYWU6EmY","title":"NFmWM0D_EggsUL8U","container":"sYsQfOtakRY8x5Mq","actions":"dYgRXjkTt7svV6AX"};